export const envApiUrl = (import.meta as any).env?.VITE_API_URL || '/api';
